export default __webpack_public_path__ + "static/quebec-a46b7e8eafefd30ae16c63837f7a7042.png";